import { Link } from "react-router";

interface LogoProps {
  className?: string;
  light?: boolean;
  linkTarget?: string;
}

export function Logo({ className, light, linkTarget = "/" }: LogoProps) {
  return (
    <Link className={className} to={linkTarget}>
      <img
        src={
          light
            ? "/media/TurtleWave_white_logo-full_canvas.svg"
            : "/media/TurtleWave_logo-full_canvas.svg"
        }
        alt="TurtleWave Logo"
        className="h-full w-full"
      />
    </Link>
  );
}
